









































































































































































































































































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import CheckBox from "@/components/CheckBox.vue";
import ConfirmationBox from "@/components/ConfirmationBox.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import StoreInOutPreAccFilterPanel from "../components/StoreInOutPreAccFilterPanel.vue";
import StoreInOutPreAccountingApi from "../services/StoreInOutPreAccountingApi";
import eventBus from "@/services/eventBus";
import auth from "@/services/auth";
import {
  StoreInOutPreAccError,
  StoreInOutPreAccLookups,
  StoreInOutPreAccRef,
  StoreInOutStatusRef,
  StoreInOutUpdatedStatus,
} from "../models/StoreInOutPreAccounting";
import { t } from "@/plugins/i18n";

interface Data {
  lookups: StoreInOutPreAccLookups | null;
  rowErrors: Record<string, StoreInOutPreAccError[]>;
  checkedRefs: StoreInOutPreAccRef[];
  reAccountRunning: boolean;
  /** A Kontírozás gomb alatti megerősítő doboz nyitva */
  reAccountConfirmOpen: boolean;
  statusActionRunning: boolean;
  takeBackConfirmVisible: boolean;
  takeBackConfirmMessage: string;
  lastItems: any[];
}

interface Methods {
  toggleChecked(item: any): void;
  refFromItem(item: any): StoreInOutPreAccRef;
  refreshCheckedRefs(items: any[]): void;
  onFieldEdit(item: any, field: "accEvent" | "note" | "accGroup"): void;
  onAccGroupEdit(item: any, value: number | null): void;
  hasTypeFilter(apiSearch: any): boolean;
  clearTypeFilters(apiSearch: any): void;
  accGroupLabel(id: number): string;
  openEdit(item: any): void;
  toggleErrors(item: any): Promise<void>;
  errorsFor(item: any): StoreInOutPreAccError[];
  syncCheckedItems(items: any[]): void;
  invalidateRowCaches(refs: StoreInOutPreAccRef[]): void;
  reAccountSelected(): Promise<void>;
  checkPermission(name: string): boolean;
  statusRefs(): StoreInOutStatusRef[];
  notAccountedLines(): string[];
  dropCheckedRefsByKey(keys: string[]): void;
  dropCheckedRefsByMixId(updated: StoreInOutUpdatedStatus[]): void;
  runStatusAction(action: () => Promise<void | boolean>): Promise<void>;
  setStatus(status: number): Promise<void>;
  bookSelected(): Promise<void>;
  takeBackSelected(confirmed: boolean): Promise<void>;
  emitStatusLines(lines: string[], successMessage: string): void;
  onItemsLoaded(items: any[]): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    ConfirmationBox,
    ApiSearchPage,
    CheckBox,
    MoneyDisplay,
    StoreInOutPreAccFilterPanel,
  },

  data() {
    return {
      lookups: null,
      rowErrors: {},
      checkedRefs: [],
      reAccountRunning: false,
      reAccountConfirmOpen: false,
      statusActionRunning: false,
      takeBackConfirmVisible: false,
      takeBackConfirmMessage: "",
      lastItems: [],
    };
  },

  async beforeMount() {
    this.lookups = await StoreInOutPreAccountingApi.getLookups();
  },

  methods: {
    // K2D pb_modify: a MIX kontírozás szerkesztése a számla előkontírozás
    // szerkesztőjében (K2D w_response_mix, ii_oper = 7: a T/K tételek írhatók,
    // a fej nem; a szerkeszthetőséget a backend Editable flagje dönti el —
    // 4-es/6-os státuszon vagy tiltott főkönyvi számon read-only-ra vált)
    // A returnTo paraméterrel a szerkesztő Mégse gombja ide, és nem a számla
    // előkontírozás böngészőjére tér vissza.
    openEdit(item: any) {
      if (item.mixId <= 1) return;
      this.$router.push({
        path: `/pre-accounting/MIX/${item.mixId}/edit`,
        query: { returnTo: this.$route.path },
      });
    },

    // Hibalista-nézet nyitása/zárása (⚠ gomb) — csak hibás soron aktív
    async toggleErrors(item: any) {
      if (item.selected) {
        item.selected = false;
        return;
      }
      const key = `${item.mixId}`;
      if (!this.rowErrors[key]) {
        const errors = await StoreInOutPreAccountingApi.getErrors(item.mixId);
        Vue.set(this.rowErrors, key, errors);
      }
      item.selected = true;
    },

    errorsFor(item: any): StoreInOutPreAccError[] {
      return this.rowErrors[`${item.mixId}`] ?? [];
    },

    refFromItem(item: any): StoreInOutPreAccRef {
      return {
        key: item.key,
        storeIn: item.storeIn,
        gStoreIn: item.gStoreIn,
        storeOut: item.storeOut,
        period: item.period,
        parts: item.parts,
        stockValueDiff: item.stockValueDiff,
        accGroup: item.accGroup,
        accEvent: item.accEvent,
        note: item.note,
        accStatus: item.accStatus,
        mixId: item.mixId,
        docTypeName: item.docTypeName,
        docNumber: item.docNumber,
      };
    },

    // A pipa-lista (K2D treff) lapozáson át is megmarad — ebből fut a csoportos
    // kontírozás és a státusz állítás
    toggleChecked(item: any) {
      item.selectedStatus = !item.selectedStatus;
      const idx = this.checkedRefs.findIndex((x) => x.key === item.key);
      if (item.selectedStatus && idx < 0) {
        this.checkedRefs.push(this.refFromItem(item));
      } else if (!item.selectedStatus && idx >= 0) {
        this.checkedRefs.splice(idx, 1);
      }
    },

    // Az ApiSearchPage @items eseménye a friss találat-listát adja — ebből frissülnek a
    // kijelölt sorok tárolt adatai, és visszaállnak a pipák.
    onItemsLoaded(items: any[]): void {
      this.refreshCheckedRefs(items);
      // Az aktuális lap sorai — a Könyv. csoport tömeges átmásolása írja őket
      this.lastItems = items;
      this.syncCheckedItems(items);
    },

    // Lapozás/újratöltés után a pipák visszaállítása
    syncCheckedItems(items: any[]): void {
      (items ?? []).forEach((item) => {
        const ref = this.checkedRefs.find((x) => x.key === item.key);
        if (ref && !item.selectedStatus) item.selectedStatus = true;
      });
    },

    // A kijelölt sorok tárolt adatai (mix_id, státusz, könyv. csoport/esemény)
    // frissítése a friss találatból — eseménykezelőből, renderen kívül. Az inline
    // szerkesztett (edited) sorokon fordítva: ott a felhasználó értékei kerülnek
    // vissza a friss sorra, hogy a lapozás ne dobja el őket a kontírozás előtt.
    refreshCheckedRefs(items: any[]): void {
      (items ?? []).forEach((item) => {
        const idx = this.checkedRefs.findIndex((x) => x.key === item.key);
        if (idx < 0) return;

        const ref = this.checkedRefs[idx];
        if (ref.edited) {
          item.accGroup = ref.accGroup;
          item.accEvent = ref.accEvent;
          item.note = ref.note;
          this.checkedRefs.splice(idx, 1, { ...this.refFromItem(item), edited: true });
        } else {
          this.checkedRefs.splice(idx, 1, this.refFromItem(item));
        }
      });
    },

    // Inline cella-szerkesztés (K2D dw_1, 3-as mód). Az érték már a soron van
    // (v-model / onAccGroupEdit) — itt a kijelölés-lista tárolt példánya frissül,
    // hogy a Kontírozás gomb a friss értékeket küldje.
    //
    // K2D-hűen MINDHÁROM mező átmásolódik a többi treffelt (kijelölt), AZONOS
    // FAJTÁJÚ (gyári/egyéb betárolás ill. kitárolás) sorra: a Könyv. csoport a
    // dw_1::itemchanged-ben (:3212-3233), a Megjegyzés és a Könyv. esemény a
    // dw_1::ue_editchanged-ben (:3178-3207). A K2D billentyűnként másol, mi a
    // cella elhagyásakor (@change) — a végállapot azonos. A fajtát a K2D a
    // szerkesztett sor storein/gstorein/storeout mezőjéből veszi (if_os lánc),
    // nálunk a kulcs első betűje (S/G/O); a KÉK sor nem szerkeszthető. A
    // szerkesztett sornak magának nem kell kijelöltnek lennie — a K2D-ben is
    // csak a célsorok treff-je számít.
    onFieldEdit(item: any, field: "accEvent" | "note" | "accGroup") {
      const idx = this.checkedRefs.findIndex((x) => x.key === item.key);
      if (idx >= 0) this.checkedRefs.splice(idx, 1, { ...this.refFromItem(item), edited: true });

      const kind = (item.key ?? "").charAt(0);
      if (kind !== "S" && kind !== "G" && kind !== "O") return;
      const value = item[field];

      this.checkedRefs.forEach((ref, i) => {
        if (ref.key === item.key || ref.key.charAt(0) !== kind) return;
        this.checkedRefs.splice(i, 1, { ...ref, [field]: value, edited: true });
      });
      (this.lastItems ?? []).forEach((other) => {
        if (!other.selectedStatus || other.key === item.key) return;
        if ((other.key ?? "").charAt(0) !== kind) return;
        other[field] = value;
      });
    },

    // K2D pb_clear: van-e bekapcsolt tároló-típus szűrő (a gomb csak akkor aktív)
    hasTypeFilter(apiSearch: any): boolean {
      const f = apiSearch?.filter?.filters ?? {};
      return ["showStoreIn", "showGStoreIn", "showStoreOut"].some(
        (k) => f[k] && f[k].value != null && f[k].value !== "0"
      );
    },

    // K2D pb_clear::clicked: cbx_storein / cbx_gstorein / cbx_storeout = false, a
    // cbx_kek érintetlen. A három érték egy tick-ben íródik, így az ApiSearchPage
    // deep-watchere egyszer fut → egyetlen újratöltés.
    clearTypeFilters(apiSearch: any) {
      const f = apiSearch?.filter?.filters ?? {};
      ["showStoreIn", "showGStoreIn", "showStoreOut"].forEach((k) => {
        if (f[k]) f[k].value = "0";
      });
    },

    // A Könyv. csoport cella (v-autocomplete): a törlés (clearable) 1-et jelent
    onAccGroupEdit(item: any, value: number | null) {
      item.accGroup = value ?? 1;
      this.onFieldEdit(item, "accGroup");
    },

    // A nem szerkeszthető (KÉK) soron is a teljes felirat látszik, ne csak az
    // azonosító — a választék feliratából, ismeretlen azonosítóra a puszta szám
    accGroupLabel(id: number): string {
      if (!(id > 1)) return "";
      const found = ((this as any).accGroupOptions ?? []).find((x: any) => x.value === id);
      return found ? found.text : String(id);
    },

    // A lenyitó hibalista-cache a kontírozás után elavul — a következő nyitás frissen kéri le
    invalidateRowCaches(refs: StoreInOutPreAccRef[]) {
      refs.forEach((ref) => {
        Vue.delete(this.rowErrors, `${ref.mixId}`);
      });
    },

    // K2D pb_cont 3-as ága: a kijelölt be/kitárolások (újra)kontírozása egyetlen
    // hívással — a backend bizonylatonként külön tranzakcióban fut, a hibák a
    // failures listában gyűlnek (K2D Continue). A K2D megerősítő kérdése nincs
    // portolva: a gomb azonnal indít, a kimenet a jobb felső értesítési sávba megy.
    async reAccountSelected() {
      if (this.checkedRefs.length === 0) return;
      this.reAccountConfirmOpen = false;
      this.reAccountRunning = true;
      const refs = [...this.checkedRefs];
      try {
        const result = await StoreInOutPreAccountingApi.reAccount(refs);

        const lines: string[] = [];
        if (result.failures.length > 0) {
          lines.push(t("StoreInOutPreAccounting_AKovetkezoBizonylatokKontirozasaSikertelenVolt"));
          result.failures.forEach((f) => lines.push(f));
        }
        if (result.stopped) {
          lines.push(t("StoreInOutPreAccounting_AKontirozasHibanAlltMegA"));
        }
        if (lines.length > 0) {
          eventBus.$emit("error", lines.join("\n"));
        } else {
          eventBus.$emit("success", t("StoreInOutPreAccounting_AKijeloltBeKitarolasokUjrakontirozva"));
        }

        this.dropCheckedRefsByKey(result.updated.map((x) => x.key));
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.reAccountRunning = false;
        // Hibaágon is újratöltünk — a bizonylatonkénti tranzakciók részlegesen commitálhattak
        this.invalidateRowCaches(refs);
        eventBus.$emit("store-in-out-pre-acc-docs:reload");
      }
    },

    checkPermission(name: string): boolean {
      const menuPerm = auth.menuPermissions.find((x) => x.name == name);
      return menuPerm?.isGranted ?? false;
    },

    // A státusz-műveletek csak a már kontírozott (MIX fejjel bíró) sorokon
    // értelmezettek — a K2D-ben a kontírozatlan sor a szerveren futna hibára
    statusRefs(): StoreInOutStatusRef[] {
      return this.checkedRefs
        .filter((x) => x.mixId > 1)
        .map((x) => ({ code: "MIX", invNo: x.mixId, accStatus: x.accStatus }));
    },

    notAccountedLines(): string[] {
      return this.checkedRefs
        .filter((x) => x.mixId <= 1)
        .map((x) => t("StoreInOutPreAccounting_MegNincsKontirozva", [x.docTypeName, x.docNumber]));
    },

    // A sikeresen kontírozott sorok lekerülnek a kijelölésről (K2D treff = ''),
    // a hibára futottak kijelölve maradnak — így egy javítás után közvetlenül
    // újra futtatható rájuk a művelet
    dropCheckedRefsByKey(keys: string[]) {
      (keys ?? []).forEach((key) => {
        const idx = this.checkedRefs.findIndex((x) => x.key === key);
        if (idx >= 0) this.checkedRefs.splice(idx, 1);
      });
    },

    dropCheckedRefsByMixId(updated: StoreInOutUpdatedStatus[]) {
      (updated ?? []).forEach((u) => {
        const idx = this.checkedRefs.findIndex((x) => x.mixId === u.invNo);
        if (idx >= 0) this.checkedRefs.splice(idx, 1);
      });
    },

    // A státusz-menüpontok azonnal futnak — a K2D Igen/Nem kérdéseit szándékosan
    // nem portoltuk (a visszavétel ÁFA-kérdése kivétel, azt a szerver kérdezi vissza).
    // Az action false visszatérése jelzi, hogy a szerveren semmi sem módosult
    // (pl. megerősítő kérdés jött) — ilyenkor felesleges az újratöltés.
    async runStatusAction(action: () => Promise<void | boolean>) {
      if (this.statusActionRunning) return;
      this.statusActionRunning = true;
      const refs = [...this.checkedRefs];
      let reload = true;
      try {
        if ((await action()) === false) reload = false;
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.statusActionRunning = false;
        if (reload) {
          // Hibaágon is újratöltünk — a státusz állítás részlegesen commitálhatott
          this.invalidateRowCaches(refs);
          eventBus.$emit("store-in-out-pre-acc-docs:reload");
        }
      }
    },

    // A státusz-műveletek közös kimenet-kezelése: a bizonylatonkénti hibák EGY
    // összegző értesítésben, különben sikerüzenet — a jobb felső értesítési sávba.
    emitStatusLines(lines: string[], successMessage: string) {
      if (lines.length > 0) eventBus.$emit("error", lines.join("\n"));
      else eventBus.$emit("success", successMessage);
    },

    // K2D ue_menu_acc_status_csoportos 2/3/5/9 — csoportos státusz állítás
    // (a DLMP476 MIX-kompatibilis végpontján)
    setStatus(status: number) {
      if (this.checkedRefs.length === 0) return Promise.resolve();
      const successes: Record<number, string> = {
        2: t("StoreInOutPreAccounting_AKijeloltBizonylatokNemAdhatoFel"),
        3: t("StoreInOutPreAccounting_AKijeloltBizonylatokFeladhatoStatuszbaKerultek"),
        5: t("StoreInOutPreAccounting_AKijeloltBizonylatokFeladasraElokeszitveStatuszb"),
        9: t("StoreInOutPreAccounting_AKijeloltBizonylatokNemFeladandoStatuszba"),
      };
      return this.runStatusAction(async () => {
        const refs = this.statusRefs();
        const lines: string[] = [];
        const skipped = this.notAccountedLines();

        if (refs.length > 0) {
          const result = await StoreInOutPreAccountingApi.setStatuses(status, refs);
          this.dropCheckedRefsByMixId(result.updated);

          if (result.closedVatWarnings.length > 0) {
            lines.push(t("StoreInOutPreAccounting_AKovetkezoBizonylatokKonyvelesiDatumaOlyan"));
            result.closedVatWarnings.forEach((w) => lines.push(w));
          }
          if (result.failures.length > 0) {
            lines.push(t("StoreInOutPreAccounting_AKovetkezoBizonylatokStatuszanNemSikerult"));
            result.failures.forEach((f) => lines.push(f));
          }
        }
        if (skipped.length > 0) {
          lines.push(t("StoreInOutPreAccounting_AKovetkezoKijeloltSorokKimaradtak"));
          skipped.forEach((s) => lines.push(s));
        }
        this.emitStatusLines(lines, successes[status]);
      });
    },

    // K2D m_feladva ("Fők.felé feladva") — feladás a belső főkönyvbe
    // (spnaccinvsbooking, prefix 'MIX')
    bookSelected() {
      if (this.checkedRefs.length === 0) return Promise.resolve();
      return this.runStatusAction(async () => {
        const refs = this.statusRefs();
        const lines: string[] = [];
        const skipped = this.notAccountedLines();

        if (refs.length > 0) {
          // TODO: PREACCDIRECTPOST jogosultsági kulcs felvétele után a jog ténylegesen
          // kiosztható — addig a K2D alapesete él (nem Feladható kijelöltnél hibaüzenet).
          // A kulcs a számla előkontírozással közös ("egyből feladva jogosultság").
          const allowAutoPromote = this.checkPermission("PREACCDIRECTPOST");
          const result = await StoreInOutPreAccountingApi.book(refs, allowAutoPromote);
          this.dropCheckedRefsByMixId(result.updated);

          if (result.failures.length > 0) {
            lines.push(t("StoreInOutPreAccounting_AKovetkezoBizonylatokFeladasaNemSikerult"));
            result.failures.forEach((f) => lines.push(f));
          }
          if (result.closedVatWarnings.length > 0) {
            lines.push(t("StoreInOutPreAccounting_AKovetkezoBizonylatokKonyvelesiDatumaOlyan"));
            result.closedVatWarnings.forEach((w) => lines.push(w));
          }
          if (result.vatReturnWarning) {
            lines.push(result.vatReturnWarning);
          }
        }
        if (skipped.length > 0) {
          lines.push(t("StoreInOutPreAccounting_AKovetkezoKijeloltSorokKimaradtak"));
          skipped.forEach((s) => lines.push(s));
        }
        this.emitStatusLines(lines, t("StoreInOutPreAccounting_AKijeloltBizonylatokFeladasaLefutott"));
      });
    },

    // K2D m_feladvabol "Vissza feladhatóba" (31-es ág): visszavétel a főkönyvből
    // (spjbookhanding_del). Ha a visszaveendő bizonylat nyitott ÁFA bevallásban
    // szerepel, Igen/Nem kérdés jön (K2D f_control_vatret) — Igen esetén
    // confirmed=true-val fut újra a hívás.
    async takeBackSelected(confirmed: boolean) {
      if (this.checkedRefs.length === 0) return;
      this.takeBackConfirmVisible = false;
      return this.runStatusAction(async () => {
        const refs = this.statusRefs();
        const lines: string[] = [];
        const skipped = this.notAccountedLines();

        if (refs.length > 0) {
          const result = await StoreInOutPreAccountingApi.takeBack(refs, confirmed);

          if (result.needsConfirmation) {
            // Kérdés jött vissza — a szerveren semmi sem módosult, felesleges újratölteni
            this.takeBackConfirmMessage = result.confirmMessage;
            this.takeBackConfirmVisible = true;
            return false;
          }

          this.dropCheckedRefsByMixId(result.updated);
          if (result.failures.length > 0) {
            lines.push(t("StoreInOutPreAccounting_AKovetkezoBizonylatokStatuszanNemSikerult"));
            result.failures.forEach((f) => lines.push(f));
          }
        }
        if (skipped.length > 0) {
          lines.push(t("StoreInOutPreAccounting_AKovetkezoKijeloltSorokKimaradtak"));
          skipped.forEach((s) => lines.push(s));
        }
        this.emitStatusLines(lines, t("StoreInOutPreAccounting_AKijeloltBizonylatokVisszaveveAFokonyvbol"));
      });
    },
  },

  computed: {
    // A Könyv. csoport cella választéka (csaccinvgroup) — az azonosító a felirat
    // része, mert a K2D listában a szám látszik
    accGroupOptions(): any[] {
      return ((this as any).lookups?.accGroups ?? []).map((x: any) => ({
        text: `${x.id} – ${x.name}`,
        value: x.id,
      }));
    },

    // A lenyitott hibalista-nézet oszlopai — width nélkül, a table-layout: fixed
    // osztja el őket egyenlően a teljes szélességen
    errorColumns: () => [
      { field: "errTypeName", title: t("HibaTipusa") },
      { field: "note", title: t("Megjegyzes"), cell: "errorNoteTemplate" },
    ],

    // Az ApiSearchPage ebből építi a szerver felé menő filter/sort modellt és a Kendo grid
    // oszlopait — a K2D d_g_storein_storeout lényegi oszlopai; a bizonylat fajtáját a K2D
    // három külön id-oszlopa helyett egy Típus + Bizonylat oszloppár mutatja
    columns: () => [
      { cell: "commandTemplate", filterable: false, sortable: false, width: 130 },
      { field: "docNumber", title: t("Bizonylat"), width: 100, fieldClass: "right_text" },
      { field: "docTypeName", title: t("Tipus"), width: 130 },
      { field: "partnerName", title: t("Partner") },
      // KÉK sorokon: cikk (kód – megnevezés) és periódus
      { field: "partsCode", title: t("Cikk"), cell: "partsTemplate", width: 140 },
      { field: "periodName", title: t("Periodus"), width: 100 },
      { field: "projectMainCode", title: t("Projekt"), width: 110 },
      { field: "poNumber", title: t("Megrendeles"), width: 120 },
      { field: "moveTypeName", title: t("StoreInOutPreAccounting_Mozgasnem"), width: 130 },
      { field: "inOutDate", title: t("CashStatement_BizonylatDatuma"), width: 130, fieldClass: "right_text" },
      { field: "netto", title: t("StoreInOutPreAccounting_NettoFt"), cell: "nettoTemplate", filterable: false, sortable: false, width: 120 },
      { field: "currNetto", title: t("StoreInOutPreAccounting_NettoDeviza"), cell: "currNettoTemplate", filterable: false, sortable: false, width: 120 },
      { field: "accGroup", title: t("StoreInOutPreAccounting_KonyvCsoport"), cell: "accGroupTemplate", filterable: false, sortable: false, width: 350 },
      { field: "accEvent", title: t("StoreInOutPreAccounting_KonyvEsemeny"), cell: "accEventTemplate", width: 300 },
      { field: "note", title: t("Megjegyzes"), cell: "noteTemplate", filterable: false, sortable: false, width: 300 },
      { field: "accDate", title: t("StoreInOutPreAccounting_KonyvDatuma"), width: 120, fieldClass: "right_text" },
      { field: "accStatusName", title: t("KonyvelesAllapot"), cell: "accStatusTemplate", width: 170 },
    ],
  },
});
